import { render, staticRenderFns } from "./productDetailAllocation.vue?vue&type=template&id=0bfa3d07&scoped=true"
import script from "./productDetailAllocation.vue?vue&type=script&lang=js"
export * from "./productDetailAllocation.vue?vue&type=script&lang=js"
import style0 from "./productDetailAllocation.vue?vue&type=style&index=0&id=0bfa3d07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfa3d07",
  null
  
)

export default component.exports